import NotificationsMenu from "./notifications-menu";

export default ({ onClick, img }) => {
    return (
        <div class="topbar-responsive">
            <div class="topbar-responsive__inner--empty">
            </div>
            <div class="topbar-responsive__inner">
                <img class="topbar-responsive__icon" src="/assets/logos/myeb.png" />
            </div>
            <div class="topbar-responsive__inner">
               <NotificationsMenu

               />
            </div>
        </div>
    )
}
